const IntegratedModelSlider = ( ( window, $, undefined ) => {


  const mobile_breakpoint = 768;
  const modelSliderSettings = {
    loop: false,
    items: 1,
    dots: false,
    nav: false,
    stagePadding: 50
  };

  let $modelSlider = $(".js_fc_integrated_model");
  let windowWidth;

  const _destroyModelSlider = () => {
    if($modelSlider.hasClass('owl-loaded')){
      $modelSlider.trigger('destroy.owl.carousel');
      $modelSlider.removeClass('owl-carousel');
    }
  }

  const _buildModelSlider = () => {
    if(!$modelSlider.hasClass('owl-loaded')){
        $modelSlider.owlCarousel(modelSliderSettings);
        $modelSlider.addClass('owl-carousel');
    }
  }

  const _checkModelSlider = () => {
     windowWidth = window.innerWidth;
     if (windowWidth < mobile_breakpoint) {
       _buildModelSlider();
     } else {
       _destroyModelSlider();
     }
  }

  const _toggleModelSlider = helpers.debounce( (e) => {
    _checkModelSlider();
  }, 100 );

  const init = () => {
    _checkModelSlider();
    window.addEventListener('resize', _toggleModelSlider);
  };

  return {
    init: init
  };

})( window, jQuery );